import styled from 'styled-components';

export const Container = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  width: 56px;
`;
